module.exports = __webpack_public_path__ + "img/enrolments-image.8d85ea54.jpg";